import React from 'react';

const SchoolMembershipCard = ({ benefits }) => {
  return (
    <div className="school-membership-card">
      <div className="limited-time-tag">SPECIAL OFFER</div>
      <h3 className="membership-title">Member schools get:</h3>
      <div className="benefits-list">
        {benefits.map((benefit, index) => (
          <div key={index} className="benefit-item">
            <span className="check-icon">✓</span>
            <span className="benefit-text">
              {benefit.text}
            </span>
          </div>
        ))}
      </div>
      <h3 className="membership-footer">All for just $250/yr!</h3>
    </div>
  );
};

export default SchoolMembershipCard; 